import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import ScrollToTop from "./views/components/ScrollToTop"; 

import Home from "./views/Home";
import WorkshopsSaturday from "./views/Step10_Workshops_Saturday";
import WorkshopsSunday from "./views/Step10_Workshops_Sunday";
import Address from "./views/Step20_Address";
import WorkshopTicket from "./views/Step30_Workshop_Ticket";
import Overview from "./views/Step40_Overview";
import Checkout from "./views/Step50_Checkout";
import Confirmation from "./views/Step60_Confirmation";

import "./css/style.css";
import "./css/progress-bar.css";

function App() {
  return (
      <BrowserRouter>
          <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/de/home" replace />} />
        <Route path="/:language/home" element={<Home />} />
        <Route path="/:language/workshops-saturday" element={<WorkshopsSaturday />} />
        <Route path="/:language/workshops-sunday" element={<WorkshopsSunday />} />
        <Route path="/:language/address" element={<Address />} />
        <Route path="/:language/workshop-ticket" element={<WorkshopTicket />} />
        <Route path="/:language/overview" element={<Overview />} />
        <Route path="/:language/checkout" element={<Checkout />} />
        <Route path="/:language/confirmation/:orderId" element={<Confirmation />} />
        <Route path="/:language/confirmation" element={<Confirmation />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
